export const DraftSections = [
  'businessInfo',
  'businessOwner',
  'finance',
  'bank',
  'coOwnerInfo',
]

export const OwnerTypes = {
  INDIVIDUAL: 'Individual',
  ENTITY: 'Entity',
}
